<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">CRM REPORTS</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Whatsapp Message Delivery Report </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Time
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="time_type"
                      :options="times"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-12 col-12">
                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-3 d-flex justify-content-end align-items-center"
                  >
                    Type
                  </div>
                  <div class="col-lg-8 col-md-6 col-9">
                    <Multiselect
                      v-model="type"
                      :options="types"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-lg-4 col-md-12 col-12 d-flex align-items-center"
              >
                <material-button
                  class="btn-background btn-sm mb-0"
                  @click="filterData()"
                  style="width: 162.52px"
                >
                  Run
                </material-button>
              </div>
            </div>
            <div class="row mt-3 ps-3">
              <div
                class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end"
              >
                Count: {{ totalRecords }}
              </div>
            </div>
            <div class="row mt-3 g-2 wa-summary">
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card">
                  <span class="summary-icon icon-sent material-icons-round"
                    >send</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Total Messages Sent</div>
                    <div class="summary-value">{{ waSummary.total_sent }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card">
                  <span class="summary-icon icon-credit material-icons-round"
                    >toll</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Total Credit Used</div>
                    <div class="summary-value">{{ waSummary.total_credit }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-12">
                <div class="summary-card summary-card-total">
                  <span class="summary-icon icon-balance material-icons-round"
                    >account_balance_wallet</span
                  >
                  <div class="summary-content">
                    <div class="summary-label">Current Credit Balance</div>
                    <div class="summary-value">
                      {{ waSummary.credit_balance }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder"
                              >
                                <span
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    () => {
                                      !!item.hasSortBy &&
                                        handleChangeSortColumn(index + 1);
                                    }
                                  "
                                  >{{ item.label }}</span
                                >
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="totalSummary.length">
                          <template v-for="row in totalSummary" :key="row.date">
                            <template v-for="(item, index) in row.data" :key="item.message_type">
                              <tr>
                                <td v-if="index === 0" :rowspan="row.data.length" class="text-center align-middle">
                                  {{ row.date }}
                                </td>
                                <td class="text-center">{{ item.message_type }}</td>
                                <td class="text-center">{{ item.total_sent }}</td>
                                <td class="text-center">{{ item.credit }}</td>
                                <td v-if="index === 0" :rowspan="row.data.length" class="text-center">{{ row.credit_balance }}</td>
                              </tr>
                            </template>
                          </template>

                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center py-4 text-muted">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialButton from "@/components/MaterialButton.vue";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
// import $ from "jquery";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";

export default {
  name: "WaMessageReport",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      pagination: {},
      page: 1,
      time_type: 0,
      type: 0,
      types: [
        { value: 0, label: "Select Type" },
        { value: 1, label: "Utility" },
        { value: 2, label: "Marketing" },
      ],
      times: [
        { value: 0, label: "Select Time" },
        { value: 1, label: "Today" },
        { value: 2, label: "Yesterday" },
        { value: 3, label: "Last 7 days" },
        { value: 4, label: "Last 30 days" },
        { value: 5, label: "This month" },
        { value: 6, label: "Last 3 months" },
        { value: 7, label: "This year" },
        { value: 8, label: "Last year" },
      ],
      totalSummary: [],
      totalRecords: 0,
      waSummary: {
        total_sent: 0,
        total_credit: 0,
        credit_balance: 0,
      },
      ESortDirectionSelect: {
        idx: null,
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
    };
  },
  created() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getList(this.page);
  },
  computed: {
    headersData() {
      return [
        {
          label: "Date",
          field: "date",
          hasSortBy: true,
        },
        {
          label: "Type",
          field: "message_type",
          hasSortBy: true,
        },
        {
          label: "Total Sent",
          field: "total_sent",
          hasSortBy: true,
        },
        {
          label: "Credit Used",
          field: "credit_used",
          hasSortBy: true,
        },
        {
          label: "Credit Balance",
          field: "credit_balance",
          hasSortBy: true,
        }
      ];
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date)
    },

    filterData() {
      this.getList(this.page);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleChangeSortColumn(idx) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc,
        };
      }

      if (this.totalSummary.length) {
        this.getList(this.page);
      }
    },

    getList(page) {
      this.showLoader();
      var dataForm = {
        time_type: this.time_type,
        type: this.type,
        page: page,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
      };
      DashboardReportService.getWaReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.totalSummary = response.data.data.items;
            this.pagination = response.data.data;
            this.totalRecords = this.pagination.total;
            if (response.data.data.wa_summary) {
              this.waSummary = response.data.data.wa_summary;
            }
            this.page = this.pagination.current_page;
            if (this.pagination.current_page > this.pagination.last_page) {
              this.page = 1;
              this.getList(this.page);
            }
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
    handleSearchEnter() {
      this.getList(this.page);
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 175px;
  padding-left: 18px;
  padding-right: 28px;
}

table thead th > span {
  position: relative;
  white-space: nowrap;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

.total-donate span {
  font-size: 18px;
  color: #222;
  font-weight: bold;
}

/* Summary cards, synced with Expiry Report. */
.wa-summary .summary-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  height: 100%;
  padding: 16px;
  border: 1px solid #eef0f3;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(20, 45, 82, 0.06);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.wa-summary .summary-card:hover {
  box-shadow: 0 10px 26px rgba(20, 45, 82, 0.1);
  transform: translateY(-2px);
}

.wa-summary .summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  font-size: 22px;
}

.wa-summary .icon-sent {
  background: linear-gradient(135deg, #4c7ef3, #6f9bff);
}

.wa-summary .icon-credit {
  background: linear-gradient(135deg, #9b5de5, #c084f5);
}

.wa-summary .icon-balance {
  background: linear-gradient(135deg, #1f6f78, #38b6a0);
}

.wa-summary .summary-content {
  min-width: 0;
}

.wa-summary .summary-card-total {
  background: linear-gradient(135deg, #f3f6ff 0%, #eef7f4 100%);
  border-color: #cfe4e0;
}

.wa-summary .summary-label {
  font-size: 11px;
  color: #8392ab;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.3;
  min-height: 30px;
}

.wa-summary .summary-value {
  margin-top: 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  word-break: break-word;
}
</style>
